module.exports = __webpack_public_path__ + "static/media/la.038868d8.svg";